import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import CCTV Systems images
import cctv1Image from '../assets/images/services/it/CCTV1.jpg';
import cctv2Image from '../assets/images/services/it/CCTV2.jpg';

// Import IT Security video (can be reused for CCTV)
import itVideo from '../assets/videos/services/IT_Security.mp4';

// Import benefits image
import cctvBenefitsImage from '../assets/images/services/it/CCTV1.jpg';

const CCTVSystemsPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="CCTV Systems" description="Professional CCTV surveillance systems installation in DRC. High-resolution cameras, remote monitoring, and security solutions by Cool & Care." keywords="CCTV systems DRC, surveillance cameras, security cameras Kinshasa, remote monitoring" />
      <ServiceSchema name="CCTV Systems" description="Professional CCTV surveillance systems installation with high-resolution cameras and remote monitoring." url="/cctv-systems" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'CCTV Systems', url: '/cctv-systems' }]} />
      <ServicePage
        serviceName={t('servicePage.services.cctvSystems.name')}
      serviceDescription={t('servicePage.services.cctvSystems.description')}
      videoUrl={itVideo}
      productImages={[
        cctv1Image,
        cctv2Image
      ]}
      features={t('servicePage.services.cctvSystems.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.cctvSystems.benefits', { returnObjects: true }) as string[]}
      benefitsImage={cctvBenefitsImage}
    />
    </>
  );
};

export default CCTVSystemsPage;
